export default {"src":"/_next/static/media/media-icon.757ad2c8.svg","height":139,"width":137,"blurWidth":0,"blurHeight":0};